import type { UseQueryResult } from '@tanstack/react-query';
import type { BaseProduct } from 'services/assist-api/entities/product/products';
import type { ResponseStatus } from 'services/assist-api/entities/test-instance-response/types';
import type { BaseTestInstanceUser } from 'services/assist-api/entities/test-instance-user/test-instance-users';
import { useTestInstanceUsers as useAPITestInstanceUsers } from 'services/assist-api/entities/test-instance-user/test-instance-users';

export type TestInstanceUser = {
  id: number;
  testInstance: {
    id: number;
    name: string;
    startDate: string;
    endDate: string;
    test: { id: number };
    area: { id: number };
  };
  tokens?: {
    id: number;
    name: string;
    value: string;
    enabled: boolean;
    validFrom: string;
    validTo: string;
  }[];
  responses?: { id: number; status: ResponseStatus; token?: { id: number } }[];
} & BaseTestInstanceUser;

export type Product = { areas: { id: number }[] } & BaseProduct;

export const useTestInstanceUsers = (
  customerUser: number,
  year: string
): UseQueryResult<RequestResponse<TestInstanceUser[]>> =>
  useAPITestInstanceUsers<TestInstanceUser>(
    {
      filters: {
        user: customerUser,
        year
      },
      groups: [
        'testinstance-name',
        'testinstance-startdate',
        'testinstance-enddate',
        'testinstance-test',
        'testinstance-area',
        'enabled',
        'token-name',
        'token-value',
        'token-validfrom',
        'token-validto',
        'testinstanceresponse-token',
        'testinstanceresponse-status'
      ],
      include: 'testInstance,tokens,responses'
    },
    { enabled: !!customerUser }
  );
